import { render, staticRenderFns } from "./Failedpayment.vue?vue&type=template&id=2f2d4b90&scoped=true&"
import script from "./Failedpayment.vue?vue&type=script&lang=js&"
export * from "./Failedpayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2d4b90",
  null
  
)

export default component.exports